<template>
  <div class="soha-avatar-container text-center">
    <div
      v-if="imageUrl"
      class="soha-avatar-wrapper"
      :style="wrapperStyle"
    >
      <Avatar
        :image="baseImageUrl + imageUrl"
        :class="{ 'soha-avatar-icon': icon }"
        shape="circle"
        class="soha-avatar-custom"
        @click.prevent.stop="showImage"
      >
        <ProgressSpinner 
          v-if="loading" 
          style="width: 50%; height: 50%" 
          stroke-width="4"
          animation-duration=".5s"
        />
      </Avatar>
    </div>

    <div
      v-else
      class="soha-avatar-svg"
      :style="svgStyle"
    >
      <inline-svg
        ref="svgTag"
        :src="avatarSrc"
      >
        <ProgressSpinner 
          v-if="loading" 
          style="width: 50%; height: 50%" 
          stroke-width="4"
          animation-duration=".5s"
        />
      </inline-svg>
    </div>

    <SohaFilePreviewDialog
      v-model:visible="showFilePreviewModal"
      :file-url="fileUrl"
      title="نمایش تصویر پرسنلی"
    />
  </div>
</template>

<script>
import Avatar from 'primevue/avatar';
import ProgressSpinner from 'primevue/progressspinner';
import SohaFilePreviewDialog from '@/view/components/base/FilePreviewDialog';

export default {
  name: "SohaAvatar",

  components: {
    Avatar,
    ProgressSpinner,
    SohaFilePreviewDialog
  },

  props: {
    baseUrl: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      default: null,
    },
    size: {
      type: Number,
      default: 32
    },
    gender: {
      default: "undefined",
      type: [String, Number],
    },
    icon: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    colorHashInput: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      showFilePreviewModal: false,
      fileUrl: null,
    }
  },

  computed: {
    avatarSrc() {
      if (this.icon) return "/media/svg/soha/icons/" + this.icon + ".svg";
      return "/media/svg/avatars/" + this.genderName + "-avatar.svg";
    },

    genderName() {
      if (this.gender == "1") return "female";
      if (this.gender == "2") return "male";
      else return "undefined";
    },

    baseImageUrl() {
      return !this.baseUrl ? this.$filesUrl: this.baseUrl;
    },

    stringToColour() {
      if (this.colorHashInput) {
        let hash = 0;
        for (let i = 0; i < this.colorHashInput.length; i++) {
          hash = this.colorHashInput.charCodeAt(i) + ((hash << 5) - hash);
        }
        let colour = "#";
        for (let i = 0; i < 3; i++) {
          let value = (hash >> (i * 8)) & 0xff;
          colour += ("00" + value.toString(16)).substr(-2);
        }
        return colour;
      }
      return null;
    },

    backgroundColor() {
      return this.getLightenColor(0.7, this.stringToColour);
    },

    wrapperStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        display: 'inline-block'
      };
    },

    svgStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      };
    }
  },

  methods: {
    getLightenColor(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = (d) => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
      (h = c0.length > 9),
        (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
        (f = this.pSBCr(c0)),
        (P = p < 0),
        (t =
          c1 && c1 != "c"
            ? this.pSBCr(c1)
            : P
            ? { r: 0, g: 0, b: 0, a: -1 }
            : { r: 255, g: 255, b: 255, a: -1 }),
        (p = P ? p * -1 : p),
        (P = 1 - p);
      if (!f || !t) return null;
      if (l)
        (r = m(P * f.r + p * t.r)),
          (g = m(P * f.g + p * t.g)),
          (b = m(P * f.b + p * t.b));
      else
        (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
          (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
          (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
      (a = f.a),
        (t = t.a),
        (f = a >= 0 || t >= 0),
        (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
      if (h)
        return (
          "rgb" +
          (f ? "a(" : "(") +
          r +
          "," +
          g +
          "," +
          b +
          (f ? "," + m(a * 1000) / 1000 : "") +
          ")"
        );
      else
        return (
          "#" +
          (
            4294967296 +
            r * 16777216 +
            g * 65536 +
            b * 256 +
            (f ? m(a * 255) : 0)
          )
            .toString(16)
            .slice(1, f ? undefined : -2)
        );
    },

    showImage() {
      this.fileUrl =this.baseImageUrl + this.imageUrl
      this.showFilePreviewModal = true;
    }
  },
};
</script>

<style scoped>
.soha-avatar-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.soha-avatar-wrapper ::v-deep(.soha-avatar-custom.p-avatar) {
  width: 100% !important;
  height: 100% !important;
}

.soha-avatar-wrapper ::v-deep(.soha-avatar-custom.p-avatar .p-avatar-icon) {
  font-size: calc(v-bind(size) * 0.5px) !important;
}

.soha-avatar-wrapper ::v-deep(.soha-avatar-custom.p-avatar img) {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}

.soha-avatar-icon ::v-deep(.p-avatar) {
  background-color: transparent;
  border: 1px solid #e0e0e0;
}

/* استایل برای حالت SVG */
.soha-avatar-svg {
  position: relative;
}

.soha-avatar-svg ::v-deep(svg) {
  width: 100% !important;
  height: 100% !important;
}

.soha-avatar-svg ::v-deep(svg g path) {
  transition: fill 0.3s ease;
  fill: v-bind(stringToColour) !important;
}

.soha-avatar-svg ::v-deep(svg g circle) {
  transition: fill 0.3s ease;
  fill: v-bind(backgroundColor) !important;
}

::v-deep(.p-progress-spinner) {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>